import { ShareUserRole } from '../enums/share-user-role.enum';
import { SubmissionState } from '../enums/submission-state.enum';
import { SystemModuleType } from '../enums/system-module-type.enum';
import { ModuleComplianceV1Read } from './module-compliance-v1-read.model';
import { ModuleSpecification } from './module-specification.model';
import { UserInfo } from './user-info.model';

export class ModuleV1Read {
    id: string;
    title: string = '';
    producerId: string = '';
    repositoryId: string = '';
    categoryId: string = '';
    categoryName: string = '';
    createdAt?: Date;
    sortOrderDate?: string;
    latestPublicVersion?: VersionReadModel;
    draftVersion?: VersionReadModel;
    submissions?: ModuleSubmissionProducerRead[] = [];
    shares: ModuleShareRead[] = [];
    author?: UserInfo;
    systemModuleType?: SystemModuleType;
    isFeatured?: boolean;

    get selectedModuleVersion(): VersionReadModel {
        if (this._selectedModuleVersion != null) {
            return this._selectedModuleVersion;
        } else if (this.draftVersion != null) {
            return this.draftVersion;
        } else {
            return this.latestPublicVersion!;
        }
    }

    set selectedModuleVersion(val: VersionReadModel) {
        this._selectedModuleVersion = val;
    }

    get isCompliant(): boolean {
        return Array.isArray(this?.latestPublicVersion?.compliances) && this.latestPublicVersion!.compliances.length > 0;
    }

    constructor(
        m?,
        public _selectedModuleVersion?: VersionReadModel,
    ) {
        if (m != null) {
            this.id = !m.id ? 'id' : m.id;
            this.title = m.title != null ? m.title : '';
            this.producerId = m.producerId != null ? m.producerId : '';
            this.repositoryId = m.repositoryId != null ? m.repositoryId : '';
            this.categoryId = m.categoryId != null ? m.categoryId : '';
            this.categoryName = m.categoryName != null ? m.categoryName : '';
            this.createdAt = m.createdAt;
            this.sortOrderDate = m.sortOrderDate;
            this.latestPublicVersion = m.latestPublicVersion;
            this.draftVersion = m.draftVersion;
            this.submissions = m.submissions != null ? m.submissions : [];
            this.shares = m.shares != null ? m.shares : [];
            this.author = m.author;
            this.systemModuleType = m.systemModuleType;
            this.isFeatured = m.isFeatured;
        }
    }
}

export class VersionReadModel {
    id: string;
    versionNumber: number;
    description: string = '';
    summary: string = '';
    image: string = '';
    isFeatured?: boolean;
    isOpenSource: boolean;
    codeDownloadUrl?: string;
    specification: ModuleSpecification;
    createdAt: Date;
    modifiedAt?: Date;
    moduleId: string;
    compliances: ModuleComplianceV1Read[] = [];
    testFileUrls: Array<string> = [];
}

export class ModuleSubmissionProducerRead {
    versionNumber?: number;
    state: SubmissionState;
    commentToProducer: string = '';
    commentToReviewer: string = '';
    isOpenSource: boolean;
    codeDownloadUrl?: string;
    testFileUrls: string[] = [];
    createdAt: string;
    modifiedAt?: string;
}

export interface ModuleSharesPayload {
    moduleShares: ModuleShareRead[];
    moduleShareErrors?: Array<unknown>;
}

export class ModuleShareRead {
    id: string;

    constructor(
        public userId: string,
        public firstName: string = '',
        public lastName: string = '',
        public picture: string = '',
        public role: ShareUserRole = ShareUserRole.Reader,
    ) {}
}
